<script setup lang="ts">
import ArrowRightSmall from '@/shared/ui/Icons/ArrowRightSmall.vue';
import { useCategories } from '@/entities/categories/composables/useCategories';
import { PRODUCT_IMAGE_PLACEHOLDER_PATH } from '@/shared/constants/placeholders';
import { CategoriesList } from '@/widgets/categoriesList';

const { category, subcategories } = useCategories();
const { t } = useI18n();
const localePath = useLocalePath();
</script>

<template>
  <div class="categories">
    <div class="categories__header">
      <nuxt-link
        class="categories__link _back"
        :to="localePath('catalog')"
        :aria-label="t('backToCategories')"
      >
        <ArrowRightSmall class="categories__icon _arrow" />
        {{ t('backToCategories') }}
      </nuxt-link>
      <div class="categories__category">
        <div class="categories__icon-wrapper">
          <div
            class="categories__icon _category"
            :style="{
              backgroundImage: `url(${category?.icon || PRODUCT_IMAGE_PLACEHOLDER_PATH})`,
            }"
            :aria-label="category?.name || ''"
          ></div>
        </div>
        {{ category?.name }}
      </div>
    </div>
    <CategoriesList :categories="subcategories" :is-parent="false" />
  </div>
</template>

<style lang="less" scoped>
.categories {
  .flex-column(@size-x4);

  border: 1px solid @color-alto;
  border-radius: @size-x4;
  background: #fff;
  padding: @size-x5 @size-x4;

  &__icon-wrapper {
    padding: @main-size;
    background-color: #fff;
    border-radius: @size-x2;
  }

  &__icon {
    &._category {
      width: @size-x10;
      height: @size-x10;
      background-size: cover;
      background-position: right;
      background-repeat: no-repeat;
      border-radius: @size-x2;
    }

    &._arrow {
      width: @size-x4;
      height: @size-x4;
      transform: rotate(180deg);
    }
  }

  &__header {
    .flex-column(@size-x4);
  }

  &__category {
    display: flex;
    align-items: center;
    gap: @size-x3;
    font-size: @size-x4;
    font-weight: 600;
    line-height: 100%;
    background-color: @color-athens-gray;
    padding: 10px @size-x4;
    margin: 0 -@size-x4;
  }

  &__link {
    .a-reset();
    font-size: @size-x4;
    line-height: 130%;
    font-weight: 500;
    color: @color-mine-shaft;
    padding: @size-x2 @size-x4;
    cursor: pointer;
    text-align: left;
    transition: background-color @A ease;

    &:hover:not(._back) {
      background: @color-athens-gray;
    }

    &._back {
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: @size-x4;
      font-weight: 600;
      line-height: 100%;
      padding: 0;
    }
  }
}
</style>
